/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { PromptStarterState, PromptStarterSlots } from './PromptStarter.types';

export const renderPromptStarter_unstable = (state: PromptStarterState): JSXElement => {
  assertSlots<PromptStarterSlots>(state);

  return (
    <state.root>
      <state.primaryAction>
        {state.icon && <state.icon />}
        {state.category && <state.category />}
        <state.prompt />
        {state.reasonMarker && <state.reasonMarker />}
      </state.primaryAction>
      {state.actions && <state.actions />}
    </state.root>
  );
};
